class ContactBubble {
    hideContactBubble = () => {
        const bubble = document.querySelector('#podium-website-widget') as any

        if (!bubble) {
            return
        }

        bubble.style.display = 'none'
    }

    showContactBubble = () => {
        const bubble = document.querySelector('#podium-website-widget') as any

        if (!bubble) {
            return
        }

        bubble.style.display = 'unset'
    }
}

export const contactBubble = new ContactBubble()
